document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-form__quantity-button').forEach(function (button) {
        button.addEventListener('click', function (event) {
            const quantityInput = document.getElementById('Quantity');
            let currentVal = parseInt(quantityInput.value, 10);
            let newQuantity;
            if (event.currentTarget.hasAttribute('data-quantity-decrease')) {
                newQuantity = currentVal > 1 ? currentVal - 1 : 1;
            } else {
                newQuantity = currentVal + 1;
            }
            quantityInput.value = newQuantity;
            document.getElementById('product-quantity').textContent = quantityInput.value;
        });
    });
});